export const DEFAULT_TAG_COLOR = '#FFFFFF'

